import {
  PaginationResponse,
  QueryCommonParams,
} from 'interfaces/pagination-response';
import axiosInstance from 'config/axios';
import { Company } from 'interfaces/company';

/**
 * @description Company response type
 * @type {CompanyResponse}
 */
export type CompanyResponse = PaginationResponse<Company>;

/**
 * @description Company service
 * @type {CompanyService}
 */
const CompanyService = {
  /**
   * @description Create company
   * @param {Partial<Company>} data - Company data
   * @returns {Promise<Company>} Company
   */
  create: (data: Partial<Company>) => {
    return axiosInstance.post<Company>('/v1/companies', data);
  },

  /**
   * @description Update company
   * @param {string | number} id - Company id
   * @param {Partial<Company>} data - Company data
   * @returns {Promise<Company>} Company
   */
  update: (id: string | number, data: Partial<Company>) => {
    return axiosInstance.patch<Company>(`/v1/companies/${id}`, data);
  },

  /**
   * @description Find company
   * @param {string | number} id - Company id
   * @returns {Promise<Company>} Company
   */
  find: (id: string | number) => {
    return axiosInstance.get<Company>(`/v1/companies/${id}`);
  },

  /**
   * @description Disable company
   * @param {string | number} id - Company id
   * @returns {Promise<Company>} Company
   */
  disable: (id: string | number) => {
    return axiosInstance.post<Company>(`/v1/companies/${id}/disable`);
  },

  /**
   * @description Delete company
   * @param {string | number} id - Company id
   * @returns {Promise<Company>} Company
   */
  delete: (id: string | number) => {
    return axiosInstance.delete<Company>(`/v1/companies/${id}`);
  },

  /**
   * @description Get companies
   * @param {QueryCommonParams} queryParams - Query parameters
   * @returns {Promise<CompanyResponse>} Company response
   */
  get: (queryParams: QueryCommonParams) => {
    return axiosInstance.get<CompanyResponse>('/v1/companies', {
      params: queryParams,
    });
  },
};

export default CompanyService;
